export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./menu.html?vue&type=template&id=02db22ca&"